import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import TextFormatter from '@tencent/wphk-components-text-formatter/index.vue';
import CouponRewardDialog from './coupon-reward-dialog.vue';
import { useNewUser } from './hooks/use-new-user';
import { CouponState } from '@tencent/wphk-components-discount-code/types/index';

// ---- use hooks ----

export default /*#__PURE__*/_defineComponent({
  __name: 'small-bar',
  setup(__props) {

const {
  isReady,
  /** 券信息 */
  couponInfo,
  /** 上报的扩展字段 */
  biExt,
  /** 是否满足展示迎新组件 */
  isShow,
  /** 点击拉起券详情弹层 */
  handleOpenRedeemCouponDialog,
  /** 点击跳转券列表 */
  handleViewCoupon,
} = useNewUser();

// ---- data ----
/** 是否已领券 */
const hasBeenReceived = computed(() => CouponState.received === couponInfo.value.state);
const isShowSmallBar = computed(() => isReady.value && isShow.value);
/** 券总额 */
const totalDiscount = computed(() => {
  const { couponList } = couponInfo.value;
  const total = couponList.reduce((total, item) => {
    const { discount } = item;
    return total + +discount;
  }, 0);
  return total;
});

// ---- 事件 ----
/** 点击btn */
function handleClickBtn() {
  if (hasBeenReceived.value) {
    // 已领取全包
    handleViewCoupon();
    return;
  }
  // 可领券
  handleOpenRedeemCouponDialog();
}

return { __sfc: true,isReady, couponInfo, biExt, isShow, handleOpenRedeemCouponDialog, handleViewCoupon, hasBeenReceived, isShowSmallBar, totalDiscount, handleClickBtn, TextFormatter, CouponRewardDialog }
}

})